import { render, staticRenderFns } from "./GtyTag.vue?vue&type=template&id=9cc6b424&scoped=true"
import script from "./GtyTag.vue?vue&type=script&lang=js"
export * from "./GtyTag.vue?vue&type=script&lang=js"
import style0 from "./GtyTag.vue?vue&type=style&index=0&id=9cc6b424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc6b424",
  null
  
)

export default component.exports